var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "person-info" },
    [
      _c("div", { staticClass: "template-title" }, [_vm._v("参赛人员资料")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "player-content" },
        [
          _c("PlayerDownLoad", {
            attrs: {
              subjectTitle: _vm.courseTitle,
              address: _vm.finalAddr + _vm.groupAddr
            }
          }),
          _vm._v(" "),
          _c("time-out", { attrs: { count: _vm.prepareTimes } })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "template-title margin-bt" }, [
        _vm._v("比赛抽取演讲节段")
      ]),
      _vm._v(" "),
      _vm._l(_vm.courseware, function(course, index) {
        return _c(
          "div",
          { key: index },
          [
            _c("upload-view", {
              attrs: {
                type: course.type,
                fileDesc: "",
                tag: "",
                deleteable: false,
                img: "",
                icon: "",
                activeIcon: course.icon,
                index: index,
                path: "",
                name: course.title,
                activityId: "",
                playerId: "",
                couldDownload: true,
                couldPreview: true,
                changeObj: { show: "", text: "" }
              },
              on: {
                download: function() {
                  return _vm.downloadAttachment(course)
                },
                preview: function() {
                  return _vm.previewAttachment(course)
                }
              }
            })
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b8d213a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b8d213a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/CourseWareDetail.vue
// module id = null
// module chunks = 